import { z } from 'zod'

const ViaCepResponseSchema = z
  .object({
    erro: z.boolean().optional(),
    logradouro: z.string().optional(),
    localidade: z.string().optional(),
    uf: z.string().optional(),
  })
  .passthrough()

export type BrazilPostalCodeAddress = {
  line1?: string
  city: string
  state: string
}

export async function lookupBrazilPostalCode(
  postalCode: string,
  signal?: AbortSignal,
): Promise<BrazilPostalCodeAddress | null> {
  const digits = postalCode.replace(/\D+/g, '')
  if (digits.length !== 8) {
    return null
  }

  const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`, { signal })
  if (!response.ok) {
    return null
  }

  const parsed = ViaCepResponseSchema.parse(await response.json())
  const city = parsed.localidade?.trim()
  const state = parsed.uf?.trim()
  if (parsed.erro || !city || !state) {
    return null
  }

  const line1 = parsed.logradouro?.trim()
  return {
    ...(line1 ? { line1 } : {}),
    city,
    state,
  }
}
